/**
 * Delivery status for shipping history
 */
export const DeliveryStatus = {
    Treated_partially: 'TREATED_PARTIALLY',
    Treated_completelly: 'TREATED_COMPLETELLY',
    Not_treated: 'NOT_TREATED'
}